import React, { Component } from "react";
import AdminDashboardComponent from './components/AdminDashboardComponent';

import PropTypes from 'prop-types';


export class AdminDashboardContainer extends Component {
    constructor (props){
        super(props)
        this.state = {
            // set any states we need for the Services page
            view:'Day',
        }

        this.updateView=this.updateView.bind(this);
    }

    updateView(selected){
        this.setState({view:selected});
    }

    render(){
        return(
            <AdminDashboardComponent 
                tab={this.props.tab} updateTab={this.props.updateTab} 
                sidePannel={this.state.sidePannel} updateSidePannel={this.updateSidePannel}
                subTab={this.state.subTab} updateSubTab={this.updateSubTab}
                view={this.state.view} updateView={this.updateView}
            />
        )
    }
          
        
}

AdminDashboardContainer.defaultProps={

}
AdminDashboardContainer.propTypes = {
    tab: PropTypes.string,
    updateTab:PropTypes.func,
    
    subtab: PropTypes.string,
    updateSubTab:PropTypes.func,
}

export default(AdminDashboardContainer);